export enum SubscriptionEdition {
    ENT = 'ENT',
    PROF = 'PROF'
}
